<template>
  <div class="page flex-v">
    <HeaderNav :topLevel="true" />
    <div class="container flex contaiBgSet">
      <div class="box scanBox flex-v"  v-if="isStudent">
        <img class="code" src="~images/qrcode.jpg" alt="" />
        <h1>您的账号身份为学生</h1>
        <p>请使用微信，扫描上方小程序二维码开始学习吧</p>
        <div class="teachBtn" @click="isStudent = ''">我是老师</div>
      </div>
      <div class="box creatCls" v-else>
        <div class="crWrap">
          <h3 class="title">请先完成班级的创建</h3>
          <CreateClass @onSuccess="$router.push('/course/home')"/>
        </div>
      </div>
    </div>
    <FooterNav v-if="isStudent" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateClass from "../course/manage/createClass.vue";
export default {
  components: {
    CreateClass
  },
  data() {
    return {
      isStudent: '',
    }
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  mounted() {
    this.isStudent = this.$route.query.isStudent;
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  justify-content: center;

  .box {
    background: #fffcf7;
    box-shadow: 0px 0 13px 1px rgba(189, 94, 39, 0.05),
      inset 0px 0 44px 13px rgba(255, 255, 255, 0.5);
  }

  .creatCls {
    width: 1200px;
    height: 100%;
    margin-top: 24px;
    .crWrap {
      width: 500px;
      margin: 0 auto;
    }
    .title {
      text-align: center;
      font-size: 24px;
      color: #333333;
      font-weight: bold;
      padding: 50px 0 40px;
    }
  }

  .scanBox {
    width: 800px;
    height: 693px;
    margin: 32px 0;
    align-items: center;
    justify-content: center;
    color: #333333;

    .code {
      width: 267px;
      height: 267px;
      margin-bottom: 53px;
    }

    h1 {
      font-size: 32px;
    }

    p {
      font-size: 21px;
      margin: 21px 0 30px;
    }

    .teachBtn {
      width: 427px;
      height: 67px;
      background: #FB7C33;
      border-radius: 133px;
      color: #ffffff;
      font-size: 21px;
      text-align: center;
      line-height: 67px;
    }
  }
}
</style>
